import { Component, input, Type } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-dynamic-icon',
  imports: [NgComponentOutlet],
  templateUrl: './dynamic-icon.html',
  styleUrl: './dynamic-icon.scss',
})
export class DynamicIconComponent {
  iconComponent = input<Type<any>>();
  stroke = input<string>('black');
  width = input<string>('1rem');
  height = input<string>('1rem');
}
